export default __webpack_public_path__ + "static/media/save-chat size-10px.be204694.svg";